import React from 'react'

const statusOptions = {
  active: 'ACTIVE',
  closed: 'CLOSED',
  inactive: 'INACTIVE',
}

function index(props: {status: string}) {

  switch (props.status.toUpperCase()) {
    case statusOptions.active:
      return(
        <div className="table-status table-status--active">
          {props.status}
        </div>
      )
    case statusOptions.closed:
      return(
        <div className="table-status table-status--closed">
          {props.status}
        </div>
      )
    case statusOptions.inactive:
      return(
        <div className="table-status table-status--inactive">
          {props.status}
        </div>
      )
    default:
      return (
        <div>
          {props.status}
        </div>
      )
  }
}

export default index